// SM25 Fingerprint Sensor - Constants
// Ported from Java SDK: Sm25Protocol.java + Sm25Client.java

// Packet prefix identifiers (little-endian on the wire)
export const PREFIX_CMD = 0xaa55;
export const PREFIX_RESP = 0x55aa;
export const PREFIX_DATA = 0xa55a;
export const PREFIX_RESPDAT = 0x5aa5;

// Commands
export const CMD_VERIFY = 0x0101;
export const CMD_IDENTIFY = 0x0102;
export const CMD_ENROLL = 0x0103;
export const CMD_ENROLL_ONE_TIME = 0x0104;
export const CMD_CLEAR_TEMPLATE = 0x0105;
export const CMD_CLEAR_ALL = 0x0106;
export const CMD_GET_EMPTY_ID = 0x0107;
export const CMD_GET_TEMPLATE_STATUS = 0x0108;
export const CMD_GET_BROKEN_TEMPLATE = 0x0109;
export const CMD_READ_TEMPLATE = 0x010a;
export const CMD_WRITE_TEMPLATE = 0x010b;
export const CMD_SET_SECURITY_LEVEL = 0x010c;
export const CMD_GET_SECURITY_LEVEL = 0x010d;
export const CMD_SET_FINGER_TIMEOUT = 0x010e;
export const CMD_GET_FINGER_TIMEOUT = 0x010f;
export const CMD_SET_DEVICE_ID = 0x0110;
export const CMD_GET_DEVICE_ID = 0x0111;
export const CMD_GET_FW_VERSION = 0x0112;
export const CMD_FINGER_DETECT = 0x0113;
export const CMD_SET_BAUDRATE = 0x0114;
export const CMD_SET_DUP_CHECK = 0x0115;
export const CMD_GET_DUP_CHECK = 0x0116;
export const CMD_ENTER_STANDBY = 0x0117;
export const CMD_ENROLL_STORE_RAM = 0x0118;
export const CMD_GET_ENROLL_DATA = 0x0119;
export const CMD_GET_FEATURE_OF_CAPTURED = 0x011a;
export const CMD_VERIFY_DOWNLOADED_FEATURE = 0x011b;
export const CMD_IDENTIFY_DOWNLOADED_FEATURE = 0x011c;
export const CMD_SET_OPERATION_MODE = 0x011d;
export const CMD_GET_OPERATION_MODE = 0x011e;
export const CMD_GET_DEVICE_NAME = 0x0121;
export const CMD_SENSOR_LED_CONTROL = 0x0124;
export const CMD_IDENTIFY_FREE = 0x0125;
export const CMD_SET_DEVICE_PASSWORD = 0x0126;
export const CMD_VERIFY_DEVICE_PASSWORD = 0x0127;
export const CMD_GET_ENROLL_COUNT = 0x0128;
export const CMD_CHANGE_TEMPLATE = 0x0129;
export const CMD_FP_CANCEL = 0x0130;
export const CMD_TEST_CONNECTION = 0x0150;

// Error/status codes
export const ERR_SUCCESS = 0x00;
export const ERR_FAIL = 0x01;
export const ERR_VERIFY = 0x0011;
export const ERR_IDENTIFY = 0x0012;
export const ERR_TMPL_EMPTY = 0x0013;
export const ERR_TMPL_NOT_EMPTY = 0x0014;
export const ERR_ALL_TMPL_EMPTY = 0x0015;
export const ERR_EMPTY_ID_NOEXIST = 0x0016;
export const ERR_BROKEN_ID_NOEXIST = 0x0017;
export const ERR_INVALID_TMPL_DATA = 0x0018;
export const ERR_DUPLICATION_ID = 0x0019;
export const ERR_BAD_QUALITY = 0x0021;
export const ERR_TIME_OUT = 0x0023;
export const ERR_NOT_AUTHORIZED = 0x0024;
export const ERR_GENERALIZE = 0x0030;
export const ERR_FP_CANCEL = 0x0041;
export const ERR_INTERNAL = 0x0050;
export const ERR_MEMORY = 0x0051;
export const ERR_EXCEPTION = 0x0052;
export const ERR_INVALID_TMPL_NO = 0x0060;
export const ERR_INVALID_SEC_VAL = 0x0061;
export const ERR_INVALID_TIME_OUT = 0x0062;
export const ERR_INVALID_BAUDRATE = 0x0063;
export const ERR_INVALID_DUP_VAL = 0x0065;
export const ERR_INVALID_PARAM = 0x0070;
export const ERR_NO_RELEASE = 0x0071;
export const ERR_INVALID_OPERATION_MODE = 0x0072;

// Guide codes
export const GD_DOWNLOAD_SUCCESS = 0x00a1;
export const GD_NEED_FIRST_SWEEP = 0xfff1;
export const GD_NEED_SECOND_SWEEP = 0xfff2;
export const GD_NEED_THIRD_SWEEP = 0xfff3;
export const GD_NEED_RELEASE_FINGER = 0xfff4;

// Human-readable code name mapping
export function codeName(code) {
	switch (code & 0xffff) {
		case 0x0011: return 'ERR_VERIFY';
		case 0x0012: return 'ERR_IDENTIFY';
		case 0x0013: return 'ERR_TMPL_EMPTY';
		case 0x0014: return 'ERR_TMPL_NOT_EMPTY';
		case 0x0015: return 'ERR_ALL_TMPL_EMPTY';
		case 0x0016: return 'ERR_EMPTY_ID_NOEXIST';
		case 0x0017: return 'ERR_BROKEN_ID_NOEXIST';
		case 0x0018: return 'ERR_INVALID_TMPL_DATA';
		case 0x0019: return 'ERR_DUPLICATION_ID';
		case 0x0021: return 'ERR_BAD_QUALITY';
		case 0x0023: return 'ERR_TIME_OUT';
		case 0x0024: return 'ERR_NOT_AUTHORIZED';
		case 0x0030: return 'ERR_GENERALIZE';
		case 0x0041: return 'ERR_FP_CANCEL';
		case 0x0050: return 'ERR_INTERNAL';
		case 0x0051: return 'ERR_MEMORY';
		case 0x0052: return 'ERR_EXCEPTION';
		case 0x0060: return 'ERR_INVALID_TMPL_NO';
		case 0x0061: return 'ERR_INVALID_SEC_VAL';
		case 0x0062: return 'ERR_INVALID_TIME_OUT';
		case 0x0063: return 'ERR_INVALID_BAUDRATE';
		case 0x0065: return 'ERR_INVALID_DUP_VAL';
		case 0x0070: return 'ERR_INVALID_PARAM';
		case 0x0071: return 'ERR_NO_RELEASE';
		case 0x0072: return 'ERR_INVALID_OPERATION_MODE';
		case 0x00a1: return 'GD_DOWNLOAD_SUCCESS';
		case 0xfff1: return 'GD_NEED_FIRST_SWEEP';
		case 0xfff2: return 'GD_NEED_SECOND_SWEEP';
		case 0xfff3: return 'GD_NEED_THIRD_SWEEP';
		case 0xfff4: return 'GD_NEED_RELEASE_FINGER';
		default: return `0x${(code & 0xffff).toString(16).padStart(4, '0')}`;
	}
}

export function isGuideCode(code) {
	const name = codeName(code);
	return name.startsWith('GD_');
}
